import dayjs from 'dayjs';

// Normalize various date string formats to strict ISO 8601 for cross-browser compatibility.
// Handles formats like:
//   "2023-01-15 10:30:00"                    → "2023-01-15T10:30:00"
//   "2026-03-05 11:21:09.612751 +0000 UTC"   → "2026-03-05T11:21:09.612751+0000"
const normalizeDate = (date: string) =>
  date
    .replace(' ', 'T') // space between date and time → T (Safari requires this)
    .replace(/\s+UTC$/, '') // remove trailing " UTC"
    .replace(/\s+([+-])/, '$1'); // remove space before timezone offset

export const isValidDate = (date: string) => {
  const parsedDate = dayjs(normalizeDate(date));
  return parsedDate.isValid();
};

/** Parses a backend date string (which is not always strict ISO) for date math. */
export const parseDate = (date: string) => dayjs(normalizeDate(date));

export const formatDate = (date?: string | null, format?: string) => {
  if (!date || !isValidDate(date)) return '';
  return dayjs(normalizeDate(date)).format(format || 'DD.MM.YY');
};

export const formatDateTime = (date?: string | null, format?: string) => {
  if (!date || !isValidDate(date)) return '';
  return dayjs(normalizeDate(date)).format(format || 'DD.MM.YY HH:mm');
};
